export const API_ENDPOINT = {
  EMPLOYEES: '/employees',
  CUSTOMERS: '/customers',
  FAC_CATEGORIES: '/fac-categories',
  FAC_TRANSPORTERS: '/fac-transporters',
  FNC_STATUS: '/fnc-status',
  FNC_GRADE: '/fnc-grades',
  ROLES: '/roles'
}
